import * as React from 'react';
import { FC } from 'react';

import { Helmet } from 'react-helmet-async';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import { BackArrowHistory } from 'components/navigation/back-arrow';
import { useSupportData } from 'hooks/use-support-data';

import { ErrorView } from '../error-view';
import { LoadingView } from '../loading-view';
import { InnerBox, PageWrap } from '../support-form-v2.styled';

import { SupportV2CategoriesView } from './support-v2-categories-view';

/**
 * Displays list of support category groups as links to their individual pages.
 */
const SupportV2CategoriesPage: FC = () => {
  const location = useLocation();
  const { formatMessage } = useIntl();
  const { supportCategoryGroups, isSupportDataLoading } = useSupportData();

  const searchParams = new URLSearchParams(location.search);
  // the following username and useremail will come from the Tims App only (in-app browswer)
  const username = searchParams.get('username') ?? '';
  const useremail = searchParams.get('useremail') ?? '';
  const fromApp = searchParams.get('fromApp') === 'true';

  const pageTitleText = formatMessage({ id: 'supportTopics' });
  const sectionTitle = formatMessage({ id: 'whatDoYouNeedHelpWith' });

  if (isSupportDataLoading) {
    return <LoadingView />;
  }

  if (!supportCategoryGroups || supportCategoryGroups.length === 0) {
    return <ErrorView message={formatMessage({ id: 'looksLikeWereExperiencingIssues' })} />;
  }

  const categoryGroups = supportCategoryGroups.map(group => ({
    _id: group?._id || '',
    name: group?.name?.locale ?? '',
  }));

  return (
    <PageWrap>
      <InnerBox>
        <BackArrowHistory />
        <Helmet title={pageTitleText} />
        <SupportV2CategoriesView
          pageTitle={pageTitleText}
          sectionTitle={sectionTitle}
          categoryGroups={categoryGroups}
          useremail={useremail}
          username={username}
          fromApp={fromApp}
        />
      </InnerBox>
    </PageWrap>
  );
};

export default SupportV2CategoriesPage;
